var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.is,{tag:"component",attrs:{"label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }